import React from "react";
import { useNavigate } from "react-router-dom";
import { SignOutMockup } from "./Mockups";
import "./landing.css";

function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="landing-inner hero-grid">
        <div className="hero-text">
          <span className="hero-badge">📍 Always know where your students are</span>
          <h1 className="hero-title">
            A digital sign-out app that <span>actually makes sense</span>
          </h1>
          <p className="hero-desc">
            Ditch the messy paper sheets and clunky Google Forms. ClassBoon gives
            teachers a real-time, school-wide view of every student's
            whereabouts — sign-outs, attendance, and emergency roll calls in one
            simple place.
          </p>
          <div className="hero-actions">
            <button
              className="landing-btn landing-btn--primary"
              onClick={() => navigate("/register")}
            >
              Create a free account
            </button>
            <button
              className="landing-btn landing-btn--ghost"
              onClick={() => navigate("/about")}
            >
              See how it works
            </button>
          </div>
          <p className="hero-note">
            Free to get started · <strong>Built by a teacher</strong>, for teachers
          </p>
        </div>

        <div className="hero-image-wrap">
          <SignOutMockup />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
